module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Bold.59b37733.woff2";